define([
    "dojo/_base/declare",
    "csi/comm/GetRequest",
    "csi/gallery/Widget",
    "csi/locale"
], function(declare,GetRequest,Gallery,locale) {

    return declare(Gallery, {
        prefClass: null,

        onDrawActionRollupFullComplete: function(/*Context*/ctx, /*Action*/action, /*DOMNode*/refNode) {
            action.m_name = locale.resource(ctx.getNodeAttributeValue("RollupProcess") == "Incremental Rollup" ? "Complete" : "Restart");
            return action.toHtmlControl(ctx, refNode);
        }
    });
});